var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteMobileCedarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "148px",
    height: "38px",
    viewBox: "0 0 148 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "74CFC324-BCB4-4D1B-B138-D97913542C39") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tree-polygon{\n        stroke:#FFFFFF;\n        stroke-width:1.5;    \n        }"), /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.087786091 0.0854744946 15.2990698 0.0854744946 15.2990698 19.0925238 0.087786091 19.0925238"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-(D)-HOME---REGION",
    transform: "translate(-30.000000, -14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    transform: "translate(-10.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/logo",
    transform: "translate(39.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Tree",
    transform: "translate(0.619048, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "tree-polygon",
    points: "21.6319157 32.9333333 14.1010101 25.438154 20.1456172 19.4222222 27.6767677 26.9171579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "tree-polygon",
    points: "20.1062122 19.4222222 14.1010101 13.4454599 17.428897 10.1333333 23.4343434 16.1100957"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "tree-polygon",
    points: "0.525252525 26.9172664 6.57010449 32.9333333 14.1010101 25.4382892 8.05615814 19.4222222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    className: "tree-polygon",
    points: "14.1010101 25.3333333 20.040404 19.4221025 14.1010101 13.5111111 8.16161616 19.4221025"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "tree-polygon",
    points: "14.1010101 25.3333333 20.040404 19.4221025 14.1010101 13.5111111"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    className: "tree-polygon",
    points: "14.1010101 25.3333333 14.1010101 13.5111111 8.16161616 19.4221025"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "tree-polygon",
    points: "14.1010101 13.5111111 17.4949495 10.1332084 14.1010101 6.75555556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    className: "tree-polygon",
    points: "14.1010101 13.5111111 14.1010101 6.75555556 10.7070707 10.1332084"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    className: "tree-polygon",
    points: "14.1010101 0 14.1010101 6.75555556 17.4949495 3.37765433 14.1012582 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "tree-polygon",
    points: "14.100762 0 10.7070707 3.37765433 14.1010101 6.75555556 14.1010101 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    className: "tree-polygon",
    points: "14.1010101 38 17.4949495 36.5040795 17.4577053 28.6388825 14.1010101 25.3333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    className: "tree-polygon",
    points: "8.09580804 19.4222222 14.1010101 13.4454599 10.7731232 10.1333333 4.76767677 16.1100957"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    className: "tree-polygon",
    points: "17.4949495 10.1333333 14.1010101 6.75543153 17.4949495 3.37777778 20.8888889 6.75543153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    className: "tree-polygon",
    points: "10.7071953 10.1333333 14.1010101 6.75543153 10.7071953 3.37777778 7.31313131 6.75543153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    className: "tree-polygon",
    points: "10.7440693 28.6388825 10.7070707 36.5040795 14.1010101 38 14.1010101 25.3333333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Word-Mark",
    transform: "translate(39.619048, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2103631,1.03 L17.2103631,5.0652381 C16.0264678,4.685 14.3102654,4.18809524 11.8239166,4.18809524 C7.35557319,4.18809524 4.958143,6.29309524 4.958143,10.0359524 C4.958143,14.1007143 7.97703992,15.9721429 11.7354798,15.9430952 C13.9548317,15.9135714 15.9081506,15.387381 17.2397617,15.0071429 L17.2397617,19.2764286 C15.1384861,19.715 12.9784133,19.9195238 11.3802871,19.9195238 C5.19501845,19.9195238 0.164246499,17.0540476 0.164246499,10.0652381 C0.164246499,3.25214286 5.66876936,0.211190476 11.4393253,0.211190476 C13.0080528,0.211190476 15.3756025,0.474285714 17.2103631,1.03",
    id: "Fill-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#FFFFFF",
    points: "28.6327722 8.01871429 38.0142932 8.01871429 38.0142932 11.703 28.6327722 11.703 28.6327722 15.7382381 39.1979475 15.7382381 39.1979475 19.5687143 24.0458706 19.5687143 24.0458706 0.562285714 38.9907116 0.562285714 38.9907116 4.3927619 28.6327722 4.3927619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0409346,17.8726905 C58.3739191,17.8726905 61.4518541,14.9193571 61.4518541,10.0653095 C61.4518541,5.29911905 58.6994722,2.25816667 52.3069676,2.25816667 L48.460091,2.25816667 L48.460091,17.8726905 L52.0409346,17.8726905 Z M63.4345716,10.0945952 C63.4345716,16.849119 58.2259623,19.5686429 52.6624013,19.5686429 L46.5954498,19.5686429 L46.5954498,0.562214286 L52.8992767,0.562214286 C58.4922363,0.562214286 63.4345716,3.01816667 63.4345716,10.0945952 Z",
    id: "Fill-21",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2009969,2.11190476 C76.7505866,4.39261905 75.1527014,7.84309524 73.3473394,12.3169048 L82.9951344,12.3169048 C80.8644602,7.1997619 78.9405399,3.25214286 78.2009969,2.11190476 M83.6758802,14.0128571 L72.6668345,14.0128571 C72.0157282,15.7380952 71.3055838,17.5802381 70.5954394,19.5685714 L68.7011587,19.5685714 C72.163444,9.07119048 76.247919,1.81928571 77.1650584,0.562142857 L79.3550117,0.562142857 C80.2133539,1.81928571 84.2677074,9.07119048 87.7596323,19.5685714 L85.7769149,19.5685714 C85.0961691,17.6388095 84.3860246,15.767619 83.6758802,14.0128571",
    id: "Fill-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(93.738099, 0.476190)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6354379,5.90490476 C12.6354379,2.77585714 10.0902919,1.78204762 7.36803144,1.78204762 L1.95218627,1.78204762 L1.95218627,10.0863333 L7.24923226,10.0863333 C9.43918558,10.0863333 12.6354379,9.47228571 12.6354379,5.90490476 M6.86488196,11.7825238 L1.95218627,11.7825238 L1.95218627,19.0925238 L0.087786091,19.0925238 L0.087786091,0.0860952381 L7.66370406,0.0860952381 C10.0016142,0.0568095238 14.6183963,1.05085714 14.6183963,5.81704762 C14.6183963,9.70633333 11.8069762,11.4020476 9.2025511,11.6944286 C12.1325294,14.6770476 15.0916652,18.8001429 15.2991421,19.0925238 L12.7539961,19.0925238 C12.6354379,18.8584762 10.3271673,15.2913333 6.86488196,11.7825238",
    id: "Fill-25",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMobileCedarLogo);
export default __webpack_public_path__ + "static/media/white_mobile_cedar_logo.8573df1299559467c7851719530950b2.svg";
export { ForwardRef as ReactComponent };